module.exports = __webpack_public_path__ + "static/media/img_dog_taki.691556ea.svg";